<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2021-09-15 11:40:44
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-03-23 23:40:49
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/nantong/dialog/justShow/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <dialogComp class="dialog" ref="dialog">
    <div class="box">
      <videoComp ref="videoComp" videoId="wanghongVideo"
        :src="'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-video.mp4'"
        :poster="'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-poster.jpeg'"
      ></videoComp>
    </div>
  </dialogComp>
</template>
<script>
import dialogComp from '@/components/dialog/index.vue';
import videoComp from '../../video.vue'
export default {
  data() {
    return {
      html: '',
      title: '',
    };
  },
  components: {
    dialogComp,
    videoComp
  },
  methods: {
    show() {
      this.$refs.dialog.show();
      let timer = setTimeout(()=>{
        clearTimeout(timer)
        this.$refs.videoComp.play();
      },500)
    },
    close() {
      this.$refs.dialog.close();
      this.$refs.videoComp.pause();
    },
  },
};
</script>

<style lang="less" scoped="true">
.dialog{
  /deep/ .popup_box{
    width:342px;
  }
}
.box {
  height: 187px;
  width:342px;
  margin:0 auto;
  .title {
    position: relative;
    top: 70px;
    color: #fff;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .content {
    position: relative;
    top: 80px;
    height: calc(100% - 160px);
    padding: 20px;
    padding-top: 0;
    box-sizing: border-box;
    overflow-y: auto;
    /deep/ p {
      float: left !important;
      text-indent: 0 !important;
      color: #fff !important;
      font-size: 12px !important;
      line-height: 1.414 !important;
    }
    /deep/ * {
      font-size: 12px !important;
      background: transparent !important;
      color: #fff !important;
    }
    /deep/ img {
      width: 100% !important;
      height: inherit !important;
      display: block !important;
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }
}
</style>